"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClassNames = exports.getClasses = void 0;
const flatArray_1 = require("./flatArray");
const getClasses = (name, rawModificators, additionClassNames) => {
    var _a, _b;
    const filtered = (_a = (0, flatArray_1.flatArray)(rawModificators)) !== null && _a !== void 0 ? _a : [];
    const addition = (_b = (0, flatArray_1.flatArray)(additionClassNames)) !== null && _b !== void 0 ? _b : [];
    return [name].concat(filtered.map(modificator => `${name}--${modificator}`)).concat(addition);
};
exports.getClasses = getClasses;
const getClassNames = (name, modificators, additionClassNames) => ((0, exports.getClasses)(name, modificators, additionClassNames).join(' '));
exports.getClassNames = getClassNames;
//# sourceMappingURL=classFunctions.js.map